import SvgSearch from 'app/assets/svg/Search';
import SvgSmallClose from 'app/assets/svg/SmallClose';
import SvgStep from 'app/assets/svg/Step';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { FC, useEffect, useState } from 'react';
import { routes } from 'shared/common/routes';
import { buildRoute } from 'shared/helpers';
import { Input } from 'shared/ui';
import styled from 'styled-components';
import { Background } from 'widgets/common';

import { ISubCategory } from '../../topics';
import { SearchResults } from './ui/search-results';

interface SearchBarProps {
  allSubRubrics: ISubCategory[];
}

const defaultResults: ISubCategory[] = [
  {
    id: 189,
    name: 'Стать самозанятым',
  },
  {
    id: 197,
    name: 'Краудфандинг',
  },
  {
    id: 195,
    name: 'Привлечение инвестиций',
  },
  {
    id: 195,
    name: 'Получение кредита',
  },
  {
    id: 199,
    name: 'Реклама и продвижение',
  },
];

const defaultOftenSearchResults: ISubCategory[] = [
  {
    id: 189,
    name: 'Стать самозанятым',
  },
  {
    id: 195,
    name: 'Привлечение инвестиций',
  },
  {
    id: 199,
    name: 'Реклама и продвижение',
  },
];

export const SearchBar: FC<SearchBarProps> = ({ allSubRubrics }) => {
  const { t } = useTranslation('topics.page');
  const router = useRouter();
  const [isShowResults, setIsShowResults] = useState(false);
  const [isShowBackground, setIsShowBackground] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [filteredResults, setFilteredResults] = useState([] as ISubCategory[]);

  // const getRandomSearchArr = () => {
  //   if (allSubRubrics && allSubRubrics.length > 0) {
  //     const numbers = Array(allSubRubrics.length)
  //       .fill(0)
  //       .map((_, index) => index + 1);
  //     if (numbers.length > 0) {
  //       numbers.sort(() => Math.random() - 0.5);
  //     }
  //     const randomSearchArr = [allSubRubrics[numbers[0]], allSubRubrics[numbers[1]], allSubRubrics[numbers[2]]];
  //     return randomSearchArr;
  //   }
  //   return [] as ISubCategory[];
  // };

  const onClickHandler = (id: number) => {
    router.push(buildRoute(routes.category, { id }));
  };

  const getFilteredResults = () => {
    if (!searchString.trim()) {
      return allSubRubrics;
    }

    return allSubRubrics.filter((item) => item.name.toLowerCase().match(searchString.toLowerCase()));
  };

  useEffect(() => {
    setFilteredResults(getFilteredResults());
  }, [searchString]);
  return (
    <>
      <Background isVisible={isShowBackground} setIsVisible={setIsShowBackground} setIsShowResults={setIsShowResults} />
      <Container>
        <TitleWrapper>
          <StyledTitle>{t('serachBar.title')}</StyledTitle>
        </TitleWrapper>
        <SubTitleWrapper>
          <StyledSubTitle>{t('serachBar.subTitle')}</StyledSubTitle>
        </SubTitleWrapper>
        <InputWrapper>
          <InputContainer>
            <SearchIconWrapper>
              <SvgSearch />
            </SearchIconWrapper>
            <SearchIconMediaWrapper>
              <SvgSearch />
            </SearchIconMediaWrapper>
            <StyledInput
              placeholder={t('serachBar.placeholder')}
              onFocus={() => {
                setIsShowBackground(true);
                setIsShowResults(true);
              }}
              onInput={(e) => {
                setSearchString((e.target as HTMLInputElement).value);
              }}
              value={searchString}
            />
            {searchString.trim() !== '' && (
              <ClearIconWrapper
                onClick={() => {
                  setSearchString('');
                }}
              >
                <ClearIconContainer>
                  <SvgSmallClose />
                </ClearIconContainer>
              </ClearIconWrapper>
            )}
            {isShowResults && (
              <SearchResultsWrapper>
                <SearchResults
                  results={filteredResults}
                  isShowPopularRubrics={!searchString}
                  defaultResults={defaultResults}
                  searchString={searchString}
                  setIsShowBackground={setIsShowBackground}
                  setIsShowResults={setIsShowResults}
                />
              </SearchResultsWrapper>
            )}
          </InputContainer>
        </InputWrapper>
        <OftenSearchWrapper>
          <OftenSearchContainer>
            <OftenSearchTextWrapper>
              <OftenSearchText>{t('serachBar.oftenSearch')}</OftenSearchText>
            </OftenSearchTextWrapper>
            <SearchItemContainer>
              {defaultOftenSearchResults.map((item) => (
                <SearchItemWrapper key={item.id} onClick={() => onClickHandler(item.id)}>
                  <SearchItemText>{item.name}</SearchItemText>
                </SearchItemWrapper>
              ))}
            </SearchItemContainer>
          </OftenSearchContainer>
        </OftenSearchWrapper>
        <StepPanelWrapper>
          <StepPanelContainer>
            <StepItemWrapper>
              <StepItemTitleWrapper>
                <StepItemTitleText>{t('subBar.stepOneTitle')}</StepItemTitleText>
              </StepItemTitleWrapper>
              <StepItemSubTitleWrapper>
                <StepItemSubTitleText>{t('subBar.stepOneSubTitle')}</StepItemSubTitleText>
              </StepItemSubTitleWrapper>
            </StepItemWrapper>
            <NextStepIcon>
              <StepIconWrapper>
                <SvgStep />
              </StepIconWrapper>
            </NextStepIcon>
            <StepItemWrapper>
              <StepItemTitleWrapper>
                <StepItemTitleText>{t('subBar.stepTwoTitle')}</StepItemTitleText>
              </StepItemTitleWrapper>
              <StepItemSubTitleWrapper>
                <StepItemSubTitleText>{t('subBar.stepTwoSubTitle')}</StepItemSubTitleText>
              </StepItemSubTitleWrapper>
            </StepItemWrapper>
            <NextStepIcon>
              <StepIconWrapper>
                <SvgStep />
              </StepIconWrapper>
            </NextStepIcon>
            <StepItemWrapper>
              <StepItemTitleWrapper>
                <StepItemTitleText>{t('subBar.stepThreeTitle')}</StepItemTitleText>
              </StepItemTitleWrapper>
              <StepItemSubTitleWrapper>
                <StepItemSubTitleText>{t('subBar.stepThreeSubTitle')}</StepItemSubTitleText>
              </StepItemSubTitleWrapper>
            </StepItemWrapper>
          </StepPanelContainer>
        </StepPanelWrapper>
      </Container>
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: var(--purple);
  width: 100%;
  padding-top: 40px;

  @media (max-width: 599px) {
    padding-top: 40px;
  }
`;

const TitleWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 10px;

  @media (max-width: 599px) {
    text-align: start;
    width: 280px;
    margin-left: 20px;
  }
`;

const StyledTitle = styled.span`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);

  @media (max-width: 599px) {
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
  }
`;

const SubTitleWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 40px;

  @media (max-width: 599px) {
    text-align: start;
    width: 280px;
    margin-left: 20px;
    margin-bottom: 30px;
  }
`;

const StyledSubTitle = styled.span`
  font-size: 25px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
  margin-bottom: 10px;

  @media (max-width: 599px) {
    font-size: 19px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.58;
    letter-spacing: normal;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;

  @media (max-width: 599px) {
    padding: 0 20px;
  }
`;

const StyledInput = styled(Input)`
  border-radius: 25px;
  border: 1px solid transparent;
  padding-left: 44px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 50px;

  @media (max-width: 599px) {
    padding: 13px 50px 12px 20px;
    border: 1px solid #c1c7cd;
  }
`;

const InputContainer = styled.div`
  width: 660px;
  position: relative;
  z-index: 998;

  @media (max-width: 599px) {
    width: 100%;
  }
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  top: 15px;
  left: 20px;
  pointer-events: none;

  @media (max-width: 599px) {
    display: none;
  }
`;

const SearchIconMediaWrapper = styled.div`
  display: none;

  @media (max-width: 599px) {
    display: flex;
    position: absolute;
    top: 15px;
    right: 20px;
    pointer-events: none;
  }
`;

const ClearIconWrapper = styled.div`
  position: absolute;
  top: 13px;
  right: 20px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--gray6);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 599px) {
    top: 13px;
    right: 19px;
  }
`;

const ClearIconContainer = styled.div`
  pointer-events: none;
`;

const OftenSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 60px;

  @media (max-width: 599px) {
    margin-bottom: 60px;
  }
`;

const OftenSearchContainer = styled.div`
  width: 660px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 599px) {
    width: 100%;
    flex-direction: column;
  }
`;

const OftenSearchTextWrapper = styled.div`
  margin-right: 5px;

  @media (max-width: 599px) {
    margin-bottom: 10px;
  }
`;

const OftenSearchText = styled.span`
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  color: var(--white);
`;

const SearchItemWrapper = styled.div`
  padding: 7px 10px;
  border-radius: 15px;
  margin: 0 5px;
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 25%);
    opacity: 0.8;
  }

  max-width: 180px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: var(--white);

  @media (max-width: 599px) {
    margin-bottom: 10px;
  }
`;

const SearchItemContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 599px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
`;

const SearchItemText = styled.span`
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  color: var(--white);
`;

const StepPanelWrapper = styled.div`
  width: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 20px 0 25px 0;
`;

const StepPanelContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 599px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const StepItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 30px;

  @media (max-width: 599px) {
    justify-content: center;
    align-items: center;
    padding-right: 0;
  }
`;

const StepItemSubTitleWrapper = styled.div``;

const StepItemTitleText = styled.span`
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: var(--white);
`;

const StepItemTitleWrapper = styled.div``;

const StepItemSubTitleText = styled.span`
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
  opacity: 0.6;
`;

const NextStepIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 30px;

  @media (max-width: 599px) {
    transform: rotate(90deg);
    padding: 12px 0;
  }
`;

const StepIconWrapper = styled.div``;

const SearchResultsWrapper = styled.div`
  position: absolute;
  top: 55px;
  left: 0px;
  width: 100%;
  z-index: 998;
`;
